import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import CreditSettings from "./credits/CreditSettings";
import JackpotSetting from "./jackpotSettings/JackpotSetting";
import InitialSignupSetting from "./initialSignupSettings/InitialSignupSetting";
import ReferralManagement from "./referralManagement/ReferralManagement";

// ... (rest of the imports)

type TabKey = "credits" | "jackpot" | "initialSignup" | "referral";

const TAB_LABELS: Record<TabKey, string> = {
  credits: "Token Settings",
  jackpot: "Jackpot Settings",
  initialSignup: "Promo Configuration",
  referral: "Referral Management",
};

const CreditsManagement: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>("credits");

  const TabContent = useMemo(
    () => ({
      credits: <CreditSettings />,
      jackpot: <JackpotSetting />,
      initialSignup: <InitialSignupSetting />,
      referral: <ReferralManagement />,
    }),
    []
  );

  // ... (rest of the component structure)

  return (
    <div>
      <section className="flex justify-between items-start px-6 py-5 bg-gradient-to-r from-[#F9FBFF] to-[#F1F6FF] rounded-lg shadow-sm border border-blue-50">
        <h1 className="text-xl font-semibold text-grease-100 tracking-tight">Token Management</h1>

        <nav className="flex items-center text-sm text-lightgray-200 space-x-2 mt-1">
          <span className="st-dashboard text-lightgray-200 text-sm" aria-hidden="true" />
          <Link to="/admin/dashboard" className="hover:text-royalblue-100 transition-colors duration-150">
            Dashboard
          </Link>
          <span className="st-arrow-right text-lightgray-200 text-xs" aria-hidden="true" />
          <span className="text-royalblue-100 font-medium">Token Management</span>
        </nav>
      </section>

      <section className="bg-white rounded-lg mt-6 p-4">
        <div className="flex items-center gap-2 mx-auto my-4 p-2 bg-blue-50 rounded-full w-max">
          {(["credits", "jackpot", "initialSignup", "referral"] as const).map((tab) => (
            <button
              key={tab}
              className={`px-6 py-2 rounded-full text-sm font-medium ${
                activeTab === tab ? "bg-white text-royalblue-100" : "text-lightgray-150"
              }`}
              onClick={() => setActiveTab(tab)}
            >
              {TAB_LABELS[tab]}
            </button>
          ))}
        </div>
      </section>

      {TabContent[activeTab]}
    </div>
  );
};

export default CreditsManagement;
